import { Dialog as BaseDialog } from '@headlessui/react';
import { MutableRefObject, ReactNode } from 'react';

export type Props = {
  initialFocus?: MutableRefObject<HTMLElement | null>;
  children?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const DialogTitle = BaseDialog.Title;

export const Dialog = ({ children, initialFocus, isOpen, onClose }: Props) => {
  return (
    <BaseDialog as="div" open={isOpen} className="relative z-10" initialFocus={initialFocus} onClose={onClose}>
      <div className="fixed inset-0 z-[200] overflow-y-auto backdrop-blur-sm">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <BaseDialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            {children}
          </BaseDialog.Panel>
        </div>
      </div>
    </BaseDialog>
  );
};
